import {createGlobalStyle} from 'styled-components';

import 'react-toastify/dist/ReactToastify.css';

// @ts-ignore
import UniSansThin from "../assets/fonts/UniSansThin.otf";
// @ts-ignore
import UniSansThinItalic from "../assets/fonts/UniSansThinItalic.otf";

// @ts-ignore
import UniSansHeavy from "../assets/fonts/UniSansHeavy.otf";
// @ts-ignore
import UniSansHeavyItalic from "../assets/fonts/UniSansHeavyItalic.otf";


export default createGlobalStyle`
  @font-face {
    font-family: 'UniSansThin';
    font-style: normal;
    font-weight: 400;
    src: url(${UniSansThin});
  }

  @font-face {
    font-family: 'UniSansThinItalic';
    font-style: normal;
    font-weight: 400;
    src: url(${UniSansThinItalic});
  }

  @font-face {
    font-family: 'UniSansHeavy';
    font-style: normal;
    font-weight: 400;
    src: url(${UniSansHeavy});
  }

  @font-face {
    font-family: 'UniSansHeavyItalic';
    font-style: normal;
    font-weight: 400;
    src: url(${UniSansHeavyItalic});
  }

  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
  }

  body {
    background: #f2f2f2;
    -webkit-font-smoothing: antialiased;
  }

  body, input, button {
    font-family: Ubuntu, sans-serif;
    font-size: 16px;
    font-weight: 300;
  }

  h1, h2, h3, h4 {
    font-family: UniSansHeavy, sans-serif;
  }

  h5 {
    font-weight: 400;
    font-size: 24px;
  }

  button, a {
    cursor: pointer;
  }

  .color {
    color: #004070;
  }
`;
